var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "b94c44f710b7e2b4e5fe3581d08d1ff828a1dd11"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dfh-accounts-site@designs-for-health"] = {
  id: "b94c44f710b7e2b4e5fe3581d08d1ff828a1dd11"
};